// Phase A — Customer Portal backbone API helpers.
import axios from "axios";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const useCustomerRelationships = () =>
  useQuery({
    queryKey: ["customer-relationships"],
    queryFn: () => axios.get(`${API}/customer-relationships`).then((r) => r.data),
  });

export const useCreateRelationship = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body) =>
      axios.post(`${API}/customer-relationships`, body).then((r) => r.data),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["customer-relationships"] });
      qc.invalidateQueries({ queryKey: ["admin-tenants"] });
      qc.invalidateQueries({ queryKey: ["my-tenants"] });
    },
  });
};

export const useDeleteRelationship = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (relId) =>
      axios.delete(`${API}/customer-relationships/${relId}`).then((r) => r.data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["customer-relationships"] }),
  });
};

export const useTenantImpact = (tenantId, enabled = true) =>
  useQuery({
    queryKey: ["tenant-impact", tenantId],
    queryFn: () => axios.get(`${API}/tenants/${tenantId}/impact`).then((r) => r.data),
    enabled: enabled && !!tenantId,
  });

export const useSetTenantType = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ tenantId, tenantType, force = false }) =>
      axios
        .post(`${API}/tenants/${tenantId}/set-type`, { tenant_type: tenantType }, { params: { force } })
        .then((r) => r.data),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["customer-relationships"] });
      qc.invalidateQueries({ queryKey: ["admin-tenants"] });
    },
  });
};

export const useMyTenants = () =>
  useQuery({
    queryKey: ["my-tenants"],
    queryFn: () => axios.get(`${API}/auth/my-tenants`).then((r) => r.data),
  });

export const useAdminAllTenants = () =>
  useQuery({
    queryKey: ["admin-tenants"],
    queryFn: () => axios.get(`${API}/tenants`).then((r) => r.data),
  });
